<template>
  <div class="dg-detail">
    <div class="dg-detail__header">
        <h4 class="p-m-0">
            <i class="pi pi-cog p-mr-2" />LG (XLiFT)
        </h4>
        <small class="p-text-secondary">
            Integração com o webservice LG XLiFT.
        </small>
    </div>
    <TabView @tab-change="onTabChange">
      <TabPanel header="Detalhes">
        <div class="p-fluid p-formgrid p-grid">

          <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="service_receipt_no" v-model="serviceOrder.service_receipt_no" :disabled="true" />
              <label for="service_receipt_no">Referência</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="accepted" v-model="serviceOrder.accepted" :disabled="true" />
              <label for="accepted">Aceite</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="pat_id" v-model="serviceOrder.pat_id" :disabled="true" />
              <label for="pat_id">PAT</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="svc_status_code" v-model="serviceOrder.svc_status_code" :disabled="true" />
              <label for="svc_status_code">Código de Estado SVC</label>
            </span>
          </div>

          <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="receipt_date" v-model="serviceOrder.receipt_date" :disabled="true" />
              <label for="receipt_date">Data de Receção</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="request_date" v-model="serviceOrder.request_date" :disabled="true" />
              <label for="request_date">Data da Solicitação</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="promise_date" v-model="serviceOrder.promise_date" :disabled="true" />
              <label for="promise_date">Data Prometida</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="purchase_date" v-model="serviceOrder.purchase_date" :disabled="true" />
              <label for="purchase_date">Data de Compra</label>
            </span>
          </div>

          <div class="p-col-12 p-md-6 p-lg-4 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="contact_name" v-model="serviceOrder.contact_name" :disabled="true" />
              <label for="contact_name">Nome do Contacto</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-4 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="contact_email" v-model="serviceOrder.contact_email" :disabled="true" />
              <label for="contact_email">Email do Contacto</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-4 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="contact_phone_no" v-model="serviceOrder.contact_phone_no" :disabled="true" />
              <label for="contact_phone_no">Telefone do Contacto</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-6 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="phone1" v-model="serviceOrder.phone1" :disabled="true" />
              <label for="phone1">Telefone 1</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-6 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="phone2" v-model="serviceOrder.phone2" :disabled="true" />
              <label for="phone2">Telefone 2</label>
            </span>
          </div>

          <div class="p-col-12 p-md-6 p-lg-6 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="address_line1" v-model="serviceOrder.address_line1" :disabled="true" />
              <label for="address_line1">Morada Linha 1</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-6 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="address_line2" v-model="serviceOrder.address_line2" :disabled="true" />
              <label for="address_line2">Morada Linha 2</label>
            </span>
          </div>
          <div class="p-col-12 p-md-4 p-lg-4 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="postal_code" v-model="serviceOrder.postal_code" :disabled="true" />
              <label for="postal_code">Código Postal</label>
            </span>
          </div>
          <div class="p-col-12 p-md-4 p-lg-4 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="city_name" v-model="serviceOrder.city_name" :disabled="true" />
              <label for="city_name">Localidade</label>
            </span>
          </div>
          <div class="p-col-12 p-md-4 p-lg-4 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="state_name" v-model="serviceOrder.state_name" :disabled="true" />
              <label for="state_name">Estado</label>
            </span>
          </div>

          <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="service_product_code" v-model="serviceOrder.service_product_code" :disabled="true" />
              <label for="service_product_code">Código Produto</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="brand_code" v-model="serviceOrder.brand_code" :disabled="true" />
              <label for="brand_code">Marca</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="model_code" v-model="serviceOrder.model_code" :disabled="true" />
              <label for="model_code">Modelo</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="serial_no" v-model="serviceOrder.serial_no" :disabled="true" />
              <label for="serial_no">Nº Série</label>
            </span>
          </div>

          <div class="p-col-12 p-md-6 p-lg-4 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="warranty_flag" v-model="serviceOrder.warranty_flag" :disabled="true" />
              <label for="warranty_flag">Garantia</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-4 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="service_type_code" v-model="serviceOrder.service_type_code" :disabled="true" />
              <label for="service_type_code">Tipo Serviço</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-4 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="customer_type_code" v-model="serviceOrder.customer_type_code" :disabled="true" />
              <label for="customer_type_code">Tipo Cliente</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-4 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="special_customer_type_code" v-model="serviceOrder.special_customer_type_code" :disabled="true" />
              <label for="special_customer_type_code">Cliente Especial</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-4 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="dealer_receipt_no" v-model="serviceOrder.dealer_receipt_no" :disabled="true" />
              <label for="dealer_receipt_no">Nº Recibo Revendedor</label>
            </span>
          </div>
          <div class="p-col-12 p-md-6 p-lg-4 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="priority_flag" v-model="serviceOrder.priority_flag" :disabled="true" />
              <label for="priority_flag">Prioridade</label>
            </span>
          </div>

          <div class="p-col-12 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <InputText id="svc_engr_forwarding_content" v-model="serviceOrder.svc_engr_forwarding_content" :disabled="true" />
              <label for="svc_engr_forwarding_content">Conteúdo Encaminhamento Eng.</label>
            </span>
          </div>

          <div class="p-col-12 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <Textarea id="receipt_symptom_desc" v-model="serviceOrder.receipt_symptom_desc" :disabled="true" :autoResize="true" rows="2" />
              <label for="receipt_symptom_desc">Descrição do Sintoma do Recibo</label>
            </span>
          </div>
          <div class="p-col-12 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <Textarea id="detail_symptom_desc" v-model="serviceOrder.detail_symptom_desc" :disabled="true" :autoResize="true" rows="2" />
              <label for="detail_symptom_desc">Descrição do Sintoma Detalhado</label>
            </span>
          </div>
          <div class="p-col-12 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <Textarea id="receipt_detail" v-model="serviceOrder.receipt_detail" :disabled="true" :autoResize="true" rows="2" />
              <label for="receipt_detail">Detalhe na Receção</label>
            </span>
          </div>
          <div class="p-col-12 p-mb-3 p-mt-3">
            <span class="p-float-label">
              <Textarea id="product_symptom_desc" v-model="serviceOrder.product_symptom_desc" :disabled="true" :autoResize="true" rows="2" />
              <label for="product_symptom_desc">Descrição dos Sintomas do Produto</label>
            </span>
          </div>

        </div>
      </TabPanel>

      <TabPanel header="Integração XLiFT" v-if="patId && can('seeIntegrationLg')">
        <div class="card">
          <div v-if="patInfo && patInfo.u_reffabri && patInfo.u_reffabri.length > 0">
            <h4>
              Integração LG (XLiFT) - <span>{{ patInfo.u_reffabri }}</span>
            </h4>
            <div class="p-fluid">
              <div class="p-field p-grid">
                <div class="p-col-12 p-md-6 p-mb-3">
                  <label>Técnico (Service Engineer Code)</label>
                  <InputText v-model="form.service_engineer_code" placeholder="Ex: PT000000000" :disabled="true" />
                  <small class="text-secondary">Código registado na LG.</small>
                </div>
                <div class="p-col-12 p-md-3 p-mb-3">
                  <label>Modelo (Model Code) <span class="required-field">*</span></label>
                  <div class="p-inputgroup">
                    <InputText v-model="form.model_code" placeholder="Ex: MHXXXXX" />
                    <Button
                      :icon="modelValidationIcon"
                      :class="modelValidationButtonClass"
                      :loading="validatingModel"
                      @click="validateModelNo(false)"
                      v-tooltip.top="'Validar Modelo na LG'"
                    />
                  </div>
                  <small class="text-secondary">Modelo do Equipamento.</small>
                </div>
                <div class="p-col-12 p-md-3 p-mb-3">
                  <label>Nº Série (Serial no) <span class="required-field">*</span></label>
                  <div class="p-inputgroup">
                    <InputText v-model="form.serial_no" placeholder="Ex: 00000000" />
                    <Button
                      :icon="serialValidationIcon"
                      :class="serialValidationButtonClass"
                      :loading="validatingSerial"
                      @click="validateSerialNumber(false)"
                      v-tooltip.top="'Validar Nº Série na LG'"
                    />
                  </div>
                  <small class="text-secondary">Nº Série do equipamento.</small>
                </div>
              </div>

              <div class="p-field p-grid">
                <div class="p-col-12 p-md-3 p-mb-3">
                  <label>Data de Início <span class="required-field">*</span></label>
                  <Calendar v-model="form.start_date" dateFormat="dd-mm-yy" />
                </div>
                <div class="p-col-12 p-md-3 p-mb-3">
                  <label>Data de Receção <span class="required-field">*</span></label>
                  <Calendar v-model="form.receipt_time_stamp" dateFormat="dd-mm-yy" />
                  <small class="text-secondary">Data de recebimento do trabalho de reparo.</small>
                </div>
                <div class="p-col-12 p-md-3 p-mb-3">
                  <label>Data da Visita ao cliente</label>
                  <Calendar v-model="form.promise_date" dateFormat="dd-mm-yy" />
                </div>
                <div class="p-col-12 p-md-3 p-mb-3">
                  <label>Data da Compra <span class="required-field">*</span></label>
                  <Calendar v-model="form.purchase_date" dateFormat="dd-mm-yy" />
                </div>
                <div class="p-col-12 p-md-3 p-mb-3">
                  <label>Data de Conclusão <span class="required-field">*</span></label>
                  <Calendar v-model="form.completion_time_stamp" dateFormat="dd-mm-yy" />
                </div>
              </div>

              <hr />

              <div class="p-field p-grid">
                <div class="p-col-12 p-md-3 p-mb-3">
                  <label>Cód. Sintoma (Symptom)</label>
                  <Dropdown
                    v-model="form.primary_symptom_code"
                    :options="listSymptom"
                    optionLabel="description"
                    optionValue="code"
                    placeholder="Selecione o código"
                  />
                </div>
                <div class="p-col-12 p-md-3 p-mb-3">
                  <label>Cód. Sintoma 2 (Symptom2) <span class="required-field">*</span></label>
                  <Dropdown
                    v-model="form.primary_symptom2_code"
                    :options="listSymptom2"
                    optionLabel="description"
                    optionValue="code"
                    placeholder="Selecione o código"
                  />
                </div>
                <div class="p-col-12 p-md-3 p-mb-3">
                  <label>Cód. Defeito (Defect) <span class="required-field">*</span></label>
                  <Dropdown
                    v-model="form.primary_defect_code"
                    :options="listDefect"
                    optionLabel="description"
                    optionValue="code"
                    placeholder="Selecione o código"
                  />
                </div>
                <div class="p-col-12 p-md-3 p-mb-3">
                  <label>Cód. Rep. Primário (Primary Repair Code) <span class="required-field">*</span></label>
                  <Dropdown
                    v-model="form.primary_repair_code"
                    :options="listPrimaryRepairCode"
                    optionLabel="description"
                    optionValue="code"
                    placeholder="Selecione o código"
                  />
                </div>
                <div class="p-col-12 p-md-3 p-mb-3 p-mt-2">
                  <label>Cód. Reparação (Repair Level Code) <span class="required-field">*</span></label>
                  <Dropdown
                    v-model="form.repair_level_code"
                    :options="listRepairLevelCode"
                    optionLabel="description"
                    optionValue="code"
                    placeholder="Selecione o código"
                  />
                </div>
              </div>

              <div class="p-field p-grid">
                <div class="p-col-12 p-md-6 p-mb-3 p-mt-2">
                  <label>Observações Técnicas (Technical finding description)</label>
                  <Textarea v-model="form.technical_finding_desc" rows="3" />
                </div>

                <div class="p-col-12 p-md-6 p-mb-3 p-mt-2">
                  <label>Observações sobre a reparação (Repair Remark)</label>
                  <Textarea v-model="form.asc_repair_remark_desc" rows="3" />
                </div>
              </div>

              <div class="p-field p-grid">
                <div class="p-col-12 p-md-3 p-mb-3">
                  <label>Valor de Deslocação</label>
                  <InputNumber
                    id="req_visit_txn_amount"
                    v-model="form.req_visit_txn_amount"
                    mode="currency"
                    currency="EUR"
                    locale="pt-PT"
                    :minFractionDigits="2"
                    :maxFractionDigits="6"
                    placeholder="Ex: 25.00"
                  />
                </div>
                <div class="p-col-12 p-md-3 p-mb-3">
                  <label>Valor de Mão de Obra</label>
                  <InputNumber
                    id="req_labor_cost_txn_amount"
                    v-model="form.req_labor_cost_txn_amount"
                    mode="currency"
                    currency="EUR"
                    locale="pt-PT"
                    :minFractionDigits="2"
                    :maxFractionDigits="6"
                    placeholder="Ex: 50.00"
                  />
                </div>
              </div>

              <hr />

              <div class="p-mb-3">
                <div class="p-field p-grid">
                  <div class="p-col-12 p-md-9">
                    <h5>Peças Utilizadas</h5>
                  </div>
                  <div class="p-col-12 p-md-3">
                    <Button label="Adicionar Peça" icon="pi pi-plus" class="p-button-sm p-button-outlined" @click="addPart" />
                  </div>
                </div>

                <DataTable :value="form.parts" class="p-mt-2" editMode="cell">
                  <Column field="part_no" header="Nº Peça">
                    <template #body="slotProps">
                      <InputText v-model="slotProps.data.part_no" class="p-inputtext-sm" placeholder="EBT..." />
                    </template>
                  </Column>
                  <Column field="quantity" header="Qtd" headerStyle="width: 100px">
                    <template #body="slotProps">
                      <InputNumber v-model="slotProps.data.quantity" :min="1" class="p-inputtext-sm" />
                    </template>
                  </Column>
                  <Column field="invoice_no" header="Nº Fatura" headerStyle="width: 150px">
                    <template #body="slotProps">
                      <div class="p-inputgroup">
                        <InputText v-model="slotProps.data.invoice_no" class="p-inputtext-sm" />
                        <Button
                          icon="pi pi-search"
                          class="p-button-outlined p-button-sm"
                          @click="openInvoiceDialog(slotProps.index)"
                          v-tooltip.top="'Pesquisar faturas na LG'"
                          :disabled="!slotProps.data.part_no"
                        />
                      </div>
                    </template>
                  </Column>
                  <Column header="" headerStyle="width: 50px">
                    <template #body="slotProps">
                      <Button icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger" @click="removePart(slotProps.index)" />
                    </template>
                  </Column>
                  <template #empty>
                    Nenhuma peça adicionada.
                  </template>
                </DataTable>
              </div>

              <hr />

              <div class="p-grid">
                <div class="p-col-12">
                  <h4>Anexos para LG XLiFT</h4>
                  <p class="text-secondary"><small>Selecione o ficheiro correspondente a cada categoria.</small></p>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3 p-mb-3 box-upload">
                  <div>
                    <label class="block">Ficheiro Principal (Geral)</label>
                  </div>
                  <Button
                    label="Selecionar do PAT"
                    icon="pi pi-images"
                    class="p-button-outlined p-button-sm p-mt-2"
                    @click="openSelectionDialog('main')"
                  />

                  <div class="p-mt-2" v-if="files.main.length">
                    <div
                      v-for="file in files.main"
                      :key="file.id"
                      class="lg-selected-file p-mb-3"
                    >
                      <template v-if="isPdf(file)">
                        <div class="pdf-preview-sm">
                          <i class="pi pi-file-pdf" style="font-size: 2.5rem; color: #e74c3c;"></i>
                        </div>
                      </template>

                      <template v-else>
                      <ImagePreview
                        v-if="file.file"
                        :src="getImageSource(file)"
                        height="120"
                        fileServiceMethod="getStorageFile"
                        class="p-mr-2"
                      />

                      <AuthenticatedImage
                        v-else
                        :file="file.filepath"
                        height="120"
                        fileServiceMethod="getStorageFile"
                        class="p-mr-2"
                      />
                      </template>

                      <div class="p-mt-1 p-d-flex p-jc-between p-ai-center">
                        <small>{{ file.resume || file.id }}</small>
                        <Button
                          icon="pi pi-times"
                          class="p-button-rounded p-button-text p-button-danger p-button-sm"
                          @click="removeMainFile(file.id)"
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <Button
                      label="Enviar"
                      icon="pi pi-upload"
                      class="p-button-sm p-mt-2"
                      :disabled="!files.main.length || loading"
                      @click="uploadToService('main')"
                    />
                  </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3 box-upload">
                  <div>
                    <label class="block">Foto do Sintoma</label>
                  </div>
                  <Button
                    label="Selecionar do PAT"
                    icon="pi pi-images"
                    class="p-button-outlined p-button-sm p-mt-2"
                    @click="openSelectionDialog('symptom')"
                  />

                  <div class="p-mt-2" v-if="files.symptom">
                    <template v-if="isPdf(files.symptom)">
                      <div class="pdf-preview-sm">
                        <i class="pi pi-file-pdf" style="font-size: 2.5rem; color: #e74c3c;"></i>
                        <small class="p-mt-1">{{ files.symptom.resume || files.symptom.id }}.pdf</small>
                      </div>
                    </template>

                    <template v-else>
                    <ImagePreview
                      v-if="files.symptom.file"
                      :src="getImageSource(files.symptom)"
                      height="150"
                      fileServiceMethod="getStorageFile"
                      class="p-mr-2"
                    />

                    <AuthenticatedImage
                      v-else
                      :file="files.symptom.filepath"
                      height="150"
                      fileServiceMethod="getStorageFile"
                      class="p-mr-2"
                    />
                    </template>
                  </div>

                  <div>
                    <Button
                      label="Enviar"
                      icon="pi pi-upload"
                      class="p-button-sm p-mt-2"
                      :disabled="!files.symptom || loading"
                      @click="uploadToService('symptom')"
                    />
                  </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3 box-upload">
                  <div>
                    <label class="block">Serial do Módulo</label>
                  </div>
                  <Button
                    label="Selecionar do PAT"
                    icon="pi pi-images"
                    class="p-button-outlined p-button-sm p-mt-2"
                    @click="openSelectionDialog('module')"
                  />

                  <div class="p-mt-2" v-if="files.module">
                    <template v-if="isPdf(files.module)">
                      <div class="pdf-preview-sm">
                        <i class="pi pi-file-pdf" style="font-size: 2.5rem; color: #e74c3c;"></i>
                        <small class="p-mt-1">{{ files.module.resume || files.module.id }}.pdf</small>
                      </div>
                    </template>

                    <template v-else>
                    <ImagePreview
                      v-if="files.module.file"
                      :src="getImageSource(files.module)"
                      height="150"
                      fileServiceMethod="getStorageFile"
                      class="p-mr-2"
                    />

                    <AuthenticatedImage
                      v-else
                      :file="files.module.filepath"
                      height="150"
                      fileServiceMethod="getStorageFile"
                      class="p-mr-2"
                    />
                    </template>
                  </div>

                  <div>
                    <Button
                      label="Enviar"
                      icon="pi pi-upload"
                      class="p-button-sm p-mt-2"
                      :disabled="!files.module || loading"
                      @click="uploadToService('module')"
                    />
                  </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3 box-upload">
                  <div>
                    <label class="block">Serial do Painel</label>
                  </div>
                  <Button
                    label="Selecionar do PAT"
                    icon="pi pi-images"
                    class="p-button-outlined p-button-sm p-mt-2"
                    @click="openSelectionDialog('panel')"
                  />

                  <div class="p-mt-2" v-if="files.panel">
                    <template v-if="isPdf(files.panel)">
                      <div class="pdf-preview-sm">
                        <i class="pi pi-file-pdf" style="font-size: 2.5rem; color: #e74c3c;"></i>
                        <small class="p-mt-1">{{ files.panel.resume || files.panel.id }}.pdf</small>
                      </div>
                    </template>

                    <template v-else>
                    <ImagePreview
                      v-if="files.panel.file"
                      :src="getImageSource(files.panel)"
                      height="150"
                      fileServiceMethod="getStorageFile"
                      class="p-mr-2"
                    />

                    <AuthenticatedImage
                      v-else
                      :file="files.panel.filepath"
                      height="150"
                      fileServiceMethod="getStorageFile"
                      class="p-mr-2"
                    />
                    </template>
                  </div>
                  <div>
                    <Button
                      label="Enviar"
                      icon="pi pi-upload"
                      class="p-button-sm p-mt-2"
                      :disabled="!files.panel || loading"
                      @click="uploadToService('panel')"
                    />
                  </div>
                </div>
              </div>

              <hr />

              <small class="text-secondary p-mb-3" style="display: block;"><span class="required-field">*</span> Campos obrigatórios</small>

              <div class="p-d-flex p-jc-end p-mt-4">
                <Button
                  label="Fechar Obra"
                  icon="pi pi-check-circle"
                  class="p-button-success"
                  @click.prevent="submitComplete"
                />
              </div>

              <DialogPatFiles
                :pat-id="patId"
                :show="showPatFilesDialog"
                :multiple="fileSelectionType === 'main'"
                @file-selected="onFileSelect($event, fileSelectionType)"
                @close="closeDialogPatFiles"
              ></DialogPatFiles>

              <Dialog
                header="Faturas LG"
                :visible.sync="showInvoiceDialog"
                :modal="true"
                :closable="true"
                :style="{ width: $isMobile() ? '100vw' : '60vw' }"
              >
                <div v-if="loadingInvoices" class="p-text-center p-p-4">
                  <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
                  <p class="p-mt-2">A pesquisar faturas...</p>
                </div>
                <div v-else-if="invoicesList.length === 0" class="p-text-center p-p-4">
                  <p>Nenhuma fatura encontrada para esta peça.</p>
                </div>
                <div v-else>
                  <DataTable
                    :value="invoicesList"
                    dataKey="invoice_no"
                    :expandedRows.sync="expandedInvoiceRows"
                    @row-expand="onInvoiceExpand"
                    class="p-datatable-sm"
                  >
                    <Column :expander="true" headerStyle="width: 3rem" />
                    <Column field="invoice_no" header="Nº Fatura" />
                    <Column field="erp_order_no" header="Nº Encomenda ERP" />
                    <Column field="shipment_quantity" header="Qtd Enviada" />
                    <Column field="shipment_date" header="Data Envio">
                      <template #body="slotProps">
                        {{ formatLgDate(slotProps.data.shipment_date) }}
                      </template>
                    </Column>
                    <Column header="" headerStyle="width: 5rem">
                      <template #body="slotProps">
                        <Button
                          label="Usar"
                          icon="pi pi-check"
                          class="p-button-sm p-button-success"
                          @click="onInvoiceSelect({ data: slotProps.data })"
                        />
                      </template>
                    </Column>
                    <template #expansion="slotProps">
                      <div class="p-p-3" style="background-color: #eee; border-radius: 6px;">
                        <div v-if="loadingOrderDetail[slotProps.data.invoice_no]" class="p-text-center p-p-3">
                          <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem;"></i>
                          <span class="p-ml-2">A carregar detalhes...</span>
                        </div>
                        <div v-else-if="invoiceOrderDetails[slotProps.data.invoice_no]">
                          <div class="p-grid p-mb-3">
                            <div class="p-col-12 p-md-4"><strong>Nº Encomenda:</strong> {{ invoiceOrderDetails[slotProps.data.invoice_no].order_no }}</div>
                            <div class="p-col-12 p-md-4"><strong>Estado:</strong> {{ invoiceOrderDetails[slotProps.data.invoice_no].order_status }}</div>
                            <div class="p-col-12 p-md-4"><strong>Data:</strong> {{ formatLgDateTime(invoiceOrderDetails[slotProps.data.invoice_no].order_date) }}</div>
                            <div class="p-col-12 p-md-4"><strong>Ref. Cliente:</strong> {{ invoiceOrderDetails[slotProps.data.invoice_no].customer_order_no }}</div>
                            <div class="p-col-12 p-md-4"><strong>ERP:</strong> {{ invoiceOrderDetails[slotProps.data.invoice_no].erp_order_no }}</div>
                            <div class="p-col-12 p-md-4"><strong>Utilizador:</strong> {{ invoiceOrderDetails[slotProps.data.invoice_no].input_user }}</div>
                          </div>
                          <DataTable :value="invoiceOrderDetails[slotProps.data.invoice_no].parts" class="p-datatable-sm p-mt-2">
                            <Column field="order_part_no" header="Peça" />
                            <Column field="part_description" header="Descrição" />
                            <Column field="part_order_progress_status" header="Estado" />
                            <Column field="part_order_qty" header="Qtd Encom." />
                            <Column field="part_shipment_qty" header="Qtd Enviada" />
                            <Column field="purchase_price" header="Preço (€)" />
                            <Column field="amount" header="Total (€)" />
                            <Column field="delivery_type" header="Tipo Entrega" />
                            <Column field="shipment_date" header="Data Envio">
                              <template #body="partSlot">
                                {{ formatLgDateTime(partSlot.data.shipment_date) }}
                              </template>
                            </Column>
                          </DataTable>
                        </div>
                        <div v-else class="p-text-center p-p-3">
                          <p>Sem detalhes disponíveis.</p>
                        </div>
                      </div>
                    </template>
                  </DataTable>
                </div>
                <template #footer>
                  <Button label="Fechar" icon="pi pi-times" class="p-button-text" @click="showInvoiceDialog = false" />
                </template>
              </Dialog>

            </div>
          </div>

          <div v-else>
            Não existem dados da ordem de serviço associado ao PAT.
          </div>

          <Loading :active.sync="loading" />
        </div>
      </TabPanel>

      <TabPanel header="Atualizar Estado LG" v-if="patId && can('seeIntegrationLg')">
        <div class="card">
          <div v-if="patInfo && patInfo.u_reffabri && patInfo.u_reffabri.length > 0">
            <h4>
              Atualizar Estado da Ordem de Serviço LG - <span>{{ patInfo.u_reffabri }}</span>
            </h4>
            <div class="p-fluid">
              
              <!-- Info Box displaying current live status from LG -->
              <div class="p-mb-4 p-p-3" style="background-color: #f8fafc; border-left: 4px solid #3b82f6; border-radius: 4px; box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);">
                <h5 class="p-m-0 p-mb-2" style="color: #1e3a8a; font-weight: 600;">
                  <i class="pi pi-info-circle p-mr-2"></i>Estado Atual na LG (XLiFT)
                </h5>
                <div class="p-grid">
                  <div class="p-col-12 p-md-6">
                    <strong>Estado:</strong> 
                    <span v-if="liveStatus.pending_reason_code">
                      {{ getStatusLabel(liveStatus.pending_reason_code) }}
                    </span>
                    <span v-else class="text-muted">Desconhecido / Não definido</span>
                  </div>
                  <div class="p-col-12 p-md-6">
                    <strong>Observação:</strong> 
                    <span v-if="liveStatus.asc_repair_remark_desc">
                      {{ liveStatus.asc_repair_remark_desc }}
                    </span>
                    <span v-else class="text-muted">Nenhuma observação</span>
                  </div>
                </div>
              </div>

              <div class="p-field p-grid">
                <div class="p-col-12 p-md-6 p-mb-3">
                  <label for="status_dropdown" class="p-d-block p-mb-2">Estado (Status Code) <span class="required-field">*</span></label>
                  <Dropdown
                    id="status_dropdown"
                    v-model="statusForm.pending_reason_code"
                    :options="statusOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione o estado"
                  />
                </div>
                <div class="p-col-12 p-md-6 p-mb-3">
                  <label for="status_remark" class="p-d-block p-mb-2">Observação / Comentário (Remark)</label>
                  <InputText
                    id="status_remark"
                    v-model="statusForm.asc_repair_remark_desc"
                    placeholder="Ex: Em transito para o STO"
                  />
                </div>
              </div>
              <div class="p-d-flex p-jc-end p-mt-4">
                <Button
                  label="Atualizar Estado"
                  icon="pi pi-save"
                  class="p-button-primary"
                  :disabled="!statusForm.pending_reason_code || loadingStatus"
                  @click.prevent="submitStatusUpdate"
                />
              </div>
            </div>
          </div>
          <div v-else>
            Não existem dados da ordem de serviço associado ao PAT.
          </div>
          <Loading :active.sync="loadingStatus" />
        </div>
      </TabPanel>
    </TabView>
  </div>
</template>

<script>
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import lgService from "@/services/lg.service";
import DialogPatFiles from "./DialogPatFiles.vue";
import AuthenticatedImage from "@/components/elements/AuthenticatedImage.vue";
import moment from "moment";

export default {
  name: "PatLgDetail",
  components: { TabView, TabPanel, Loading, DialogPatFiles, AuthenticatedImage },
  props: {
    serviceOrder: {
      type: Object,
      required: true,
    },
    patId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      patInfo: null,
      loading: false,
      refreshing: false,
      validatingSerial: false,
      serialValidationStatus: null,
      validatingModel: false,
      modelValidationStatus: null,
      files: {
        main: [],
        symptom: null,
        module: null,
        panel: null,
      },
      showPatFilesDialog: false,
      fileSelectionType: null,
      showUpdateDialog: false,
      showInvoiceDialog: false,
      loadingInvoices: false,
      invoicesList: [],
      invoicePartIndex: null,
      expandedInvoiceRows: [],
      invoiceOrderDetails: {},
      loadingOrderDetail: {},
      dateFormat: "DD-MM-YYYY",
      form: {
        service_engineer_code: "",
        start_date: moment().toDate(),
        completion_time_stamp: moment().toDate(),
        purchase_date: moment().toDate(),
        promise_date: moment().toDate(),
        receipt_time_stamp: moment().toDate(),
        primary_symptom_code: "",
        primary_symptom2_code: "",
        primary_defect_code: "",
        primary_repair_code: "",
        repair_level_code: "",
        technical_finding_desc: "",
        asc_repair_remark_desc: "",
        equipment_brand: "LG",
        model_code: "",
        serial_no: "",
        req_visit_txn_amount: 0.00,
        req_labor_cost_txn_amount: 0.00,
        parts: [],
      },
      pendingCodes: [
        { label: "28 - REPARAÇÃO CONCLUÍDA", value: "28" },
      ],
      statusForm: {
        pending_reason_code: "",
        asc_repair_remark_desc: "",
      },
      liveStatus: {
        pending_reason_code: "",
        asc_repair_remark_desc: "",
      },
      statusOptions: [
        { label: "L9 - Peças encomendadas", value: "L9" },
        { label: "L0 - Visita agendada", value: "L0" },
        { label: "L3 - Triagem", value: "L3" },
        { label: "N0 - Reparação Completa", value: "N0" },
      ],
      loadingStatus: false,
      listSymptom: [],
      listSymptom2: [],
      listDefect: [],
      listPrimaryRepairCode: [],
      listRepairLevelCode: [],
    };
  },
  created() {
    if (this.patId && this.can("seeIntegrationLg")) {
      this.fetchConfigCodes();
    }
  },
  async mounted() {
    if (this.patId && this.can("seeIntegrationLg")) {
      await this.getInfoPat();
      if (this.form.model_code) {
        this.validateModelNo(true);
      }
      if (this.form.serial_no) {
        this.validateSerialNumber(true);
      }
    }
  },
  computed: {
    serialValidationIcon() {
      if (this.serialValidationStatus === 'valid') return 'pi pi-check-circle';
      if (this.serialValidationStatus === 'invalid') return 'pi pi-times-circle';
      return 'pi pi-check-circle';
    },
    serialValidationButtonClass() {
      if (this.serialValidationStatus === 'valid') return 'p-button-success';
      if (this.serialValidationStatus === 'invalid') return 'p-button-danger';
      return 'p-button-outlined';
    },
    modelValidationIcon() {
      if (this.modelValidationStatus === 'valid') return 'pi pi-check-circle';
      if (this.modelValidationStatus === 'invalid') return 'pi pi-times-circle';
      return 'pi pi-check-circle';
    },
    modelValidationButtonClass() {
      if (this.modelValidationStatus === 'valid') return 'p-button-success';
      if (this.modelValidationStatus === 'invalid') return 'p-button-danger';
      return 'p-button-outlined';
    },
  },
  methods: {
    getImageSource(file) {
      return `data:image/${file.extension};base64,${file.file}`;
    },
    isPdf(file) {
      return file.extension && file.extension.toLowerCase() === 'pdf';
    },
    async fetchConfigCodes() {
      this.loading = true;
      try {
        const groupedCodes = await lgService.getGroupedConfigCodes();

        this.listSymptom = groupedCodes.symptom || [];
        this.listSymptom2 = groupedCodes.symptom2 || [];
        this.listDefect = groupedCodes.defect || [];
        this.listPrimaryRepairCode = groupedCodes.primary_repair_code || [];
        this.listRepairLevelCode = groupedCodes.repair_level_code || [];
      } finally {
        this.loading = false;
      }
    },
    async getInfoPat() {
      this.loading = true;

      try {
        const response = await lgService.getServiceRepair(this.patId);

        this.patInfo = response.pat;

        if (response.service) {
          this.form.service_engineer_code = response.service.service_engineer_code || response.service_engineer_code;
          this.form.technical_finding_desc = response.service.technical_finding_desc || "";
          this.form.asc_repair_remark_desc = response.service.asc_repair_remark_desc || "";
          this.form.primary_symptom_code = response.service.primary_symptom_code || "";
          this.form.primary_symptom2_code = response.service.primary_symptom2_code || "";
          this.form.primary_defect_code = response.service.primary_defect_code || "";
          this.form.primary_repair_code = response.service.primary_repair_code || "";
          this.form.repair_level_code = response.service.repair_level_code || "";
          this.form.start_date = this.parseDate(response.service.start_time_stamp);
          this.form.receipt_time_stamp = this.parseDate(response.service.receipt_time_stamp);
          this.form.completion_time_stamp = this.parseDate(response.service.completion_time_stamp);
          this.form.req_visit_txn_amount = response.service.req_visit_txn_amount || 0.00;
          this.form.req_labor_cost_txn_amount = response.service.req_labor_cost_txn_amount || 0.00;

          this.liveStatus.pending_reason_code = response.service.pending_reason_code || "";
          this.liveStatus.asc_repair_remark_desc = response.service.asc_repair_remark_desc || "";
          this.statusForm.pending_reason_code = "";
          this.statusForm.asc_repair_remark_desc = "";

          this.form.equipment_brand = response.service.equipment_brand || this.patInfo.equipament.marca || "LG";
          this.form.model_code = response.service.model_code || this.patInfo.equipament.maquina || "";
          this.form.serial_no = response.service.serial_no || this.patInfo.equipament.serie || "";
          this.form.purchase_date = this.parseDate(response.service.purchase_date);
          this.form.promise_date = this.parseDate(response.service.promise_date);

          this.form.parts = response.parts || [];

          if (response.service.file_main) {
            this.files.main = [response.service.file_main];
          }

          if (response.service.file_symptom) {
            this.files.symptom = response.service.file_symptom;
          }

          if (response.service.file_module) {
            this.files.module = response.service.file_module;
          }

          if (response.service.file_panel) {
            this.files.panel = response.service.file_panel;
          }
        } else {
          this.liveStatus.pending_reason_code = "";
          this.liveStatus.asc_repair_remark_desc = "";
          this.statusForm.pending_reason_code = "";
          this.statusForm.asc_repair_remark_desc = "";

          this.form.parts = [];
          this.form.start_date = this.parseDate(this.patInfo.pdata);
          this.form.receipt_time_stamp = this.parseDate(this.patInfo.pdata);
          this.form.completion_time_stamp = this.parseDate(this.patInfo.fdata);
          this.form.equipment_brand = this.patInfo.equipament.marca || "LG";
          this.form.model_code = this.patInfo.equipament.maquina || "";
          this.form.serial_no = this.patInfo.equipament.serie || "";
          this.form.purchase_date = this.parseDate(this.serviceOrder?.purchase_date);
          this.form.promise_date = this.parseDate(this.patInfo?.datat);
          this.form.service_engineer_code = response.service_engineer_code;
          this.form.asc_repair_remark_desc = this.patInfo.solucao || "";
          this.form.completion_time_stamp = moment().toDate();

          let techComments = "";
          if (this.patInfo.interventions.length > 0) {
            let finalComment = this.patInfo.interventions.find(interv => interv.mhtipo == "Técnica Final");
            techComments = finalComment ? finalComment.relatorio : "";
          }

          let parts = [];
          if (this.patInfo && this.patInfo.work_sheet_with_lines) {
            let ws = this.patInfo.work_sheet_with_lines.lines;
            parts = ws.map(line => ({
              part_no: line.ref,
              quantity: parseFloat(line.qtt)
            }));
          }

          this.form.technical_finding_desc = techComments
          this.form.parts = parts;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        const msg = error.response?.data?.message || error.message;
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: msg,
          life: 8000,
        });
      }
    },
    formatLgDate(dateStr) {
      if (!dateStr || dateStr.length !== 8) return dateStr || '';
      const parsed = moment(dateStr, "DDMMYYYY");
      return parsed.isValid() ? parsed.format("DD-MM-YYYY") : dateStr;
    },
    formatLgDateTime(dateTimeStr) {
      if (!dateTimeStr) return '';
      const parsed = moment(dateTimeStr.trim(), ["YYYYMMDD HHmmss", "DDMMYYYY HHmm", "DDMMYYYYHHmm"]);
      return parsed.isValid() ? parsed.format("DD-MM-YYYY HH:mm") : dateTimeStr;
    },
    parseLgDate(dateStr) {
      if (!dateStr || dateStr.length !== 8) return null;
      const parsed = moment(dateStr, "DDMMYYYY");
      return parsed.isValid() ? parsed.toDate() : null;
    },
    parseLgDateTime(dateTimeStr) {
      if (!dateTimeStr || dateTimeStr.length !== 12) return null;
      const parsed = moment(dateTimeStr, "DDMMYYYYHHmm");
      return parsed.isValid() ? parsed.toDate() : null;
    },
    parseDate(value) {
      if (!value) return moment().toDate();
      const parsed = moment(value, ["YYYY-MM-DD HH:mm:ss.SSS", "YYYY-MM-DD", "DD-MM-YYYY"]);
      return parsed.isValid() ? parsed.toDate() : moment().toDate();
    },
    formatDate(value) {
      if (!value) return null;
      return moment(value).format(this.dateFormat);
    },
    openSelectionDialog(type) {
      this.showPatFilesDialog = true;
      this.fileSelectionType = type;
    },
    closeDialogPatFiles() {
      this.showPatFilesDialog = false;
      this.fileSelectionType = null;
    },
    onFileSelect(event, type) {
      if (!Object.keys(this.files).includes(type)) {
        return;
      }

      if (type === "main") {
        const selectedFiles = Array.isArray(event) ? event : [event];
        const existingIds = new Set(this.files.main.map((file) => file.id));
        this.files.main = [
          ...this.files.main,
          ...selectedFiles.filter((file) => !existingIds.has(file.id)),
        ];
        return;
      }

      this.files[type] = event;
    },
    removeMainFile(fileId) {
      this.files.main = this.files.main.filter((file) => file.id !== fileId);
    },
    async uploadToService(type) {
      if (type === "main" && !this.files.main.length) {
        return;
      }

      if (type !== "main" && !this.files[type]) {
        return;
      }

      this.loading = true;

      try {
        const filesToUpload = type === "main" ? this.files.main : [this.files[type]];

        for (const file of filesToUpload) {
          const data = {
            file: file,
            origin_reference: this.patInfo.u_reffabri,
            resume: `Upload do ficheiro ${type} para LG XLiFT via Intranet.`,
            lg_file_type: type,
            pat_id: this.patId,
          };

          const response = await lgService.addFile(data);
          if (!response) {
            throw new Error("Erro ao atualizar a reparação na LG.");
          }
        }

        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: type === "main"
            ? `${filesToUpload.length} ficheiro(s) principais enviados para a LG com sucesso.`
            : `Ficheiro (${type}) enviado para a LG com sucesso.`,
          life: 5000,
        });

        if (type === "main") {
          this.files.main = [];
        } else {
          this.files[type] = null;
        }
      } catch (error) {
        let msg = error.response?.data?.message || error.message;
        if (error.response?.data?.lg_error) {
          msg += " (LG Error: " + JSON.stringify(error.response.data.lg_error) + ")";
        }

        this.$toast.add({
          severity: "error",
          summary: "Erro no Envio",
          detail: msg,
          life: 8000,
        });
      } finally {
        this.loading = false;
      }
    },
    async validateModelNo(silent = false) {
      if (!this.form.model_code || !this.form.model_code.trim()) {
        if (!silent) {
          this.$toast.add({
            severity: "warn",
            summary: "Modelo",
            detail: "Preencha o Modelo antes de validar.",
            life: 5000,
          });
        }
        this.modelValidationStatus = null;
        return;
      }

      this.validatingModel = true;
      this.modelValidationStatus = null;
      try {
        const response = await lgService.validateModelNo(this.form.model_code.trim());
        this.modelValidationStatus = 'valid';
        if (!silent) {
          this.$toast.add({
            severity: "success",
            summary: "Modelo Válido",
            detail: response.message || "Modelo validado com sucesso na LG.",
            life: 5000,
          });
        }
      } catch (error) {
        this.modelValidationStatus = 'invalid';
        if (!silent) {
          const msg = error.response?.data?.message || error.message;
          this.$toast.add({
            severity: "error",
            summary: "Modelo Inválido",
            detail: msg,
            life: 8000,
          });
        }
      } finally {
        this.validatingModel = false;
      }
    },
    async validateSerialNumber(silent = false) {
      if (!this.form.serial_no || !this.form.serial_no.trim()) {
        if (!silent) {
          this.$toast.add({
            severity: "warn",
            summary: "Nº Série",
            detail: "Preencha o Nº Série antes de validar.",
            life: 5000,
          });
        }
        this.serialValidationStatus = null;
        return;
      }

      this.validatingSerial = true;
      this.serialValidationStatus = null;
      try {
        const response = await lgService.validateSerialNumber(this.form.serial_no.trim());
        this.serialValidationStatus = 'valid';
        if (!silent) {
          this.$toast.add({
            severity: "success",
            summary: "Nº Série Válido",
            detail: response.message || "Número de série validado com sucesso na LG.",
            life: 5000,
          });
        }
      } catch (error) {
        this.serialValidationStatus = 'invalid';
        if (!silent) {
          const msg = error.response?.data?.message || error.message;
          this.$toast.add({
            severity: "error",
            summary: "Nº Série Inválido",
            detail: msg,
            life: 8000,
          });
        }
      } finally {
        this.validatingSerial = false;
      }
    },
    async openInvoiceDialog(partIndex) {
      const part = this.form.parts[partIndex];
      if (!part || !part.part_no || !part.part_no.trim()) {
        this.$toast.add({
          severity: "warn",
          summary: "Peça",
          detail: "Preencha o Nº da Peça antes de pesquisar faturas.",
          life: 5000,
        });
        return;
      }

      this.invoicePartIndex = partIndex;
      this.invoicesList = [];
      this.expandedInvoiceRows = [];
      this.invoiceOrderDetails = {};
      this.loadingOrderDetail = {};
      this.showInvoiceDialog = true;
      this.loadingInvoices = true;

      try {
        const response = await lgService.retrieveInvoiceNumber(part.part_no.trim());
        this.invoicesList = response.invoices || [];
      } catch (error) {
        const msg = error.response?.data?.message || error.message;
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: msg,
          life: 8000,
        });
        this.showInvoiceDialog = false;
      } finally {
        this.loadingInvoices = false;
      }
    },
    onInvoiceSelect(event) {
      if (this.invoicePartIndex !== null && event.data) {
        this.$set(this.form.parts[this.invoicePartIndex], 'invoice_no', event.data.invoice_no);
      }
      this.showInvoiceDialog = false;
      this.invoicePartIndex = null;
    },
    async onInvoiceExpand(event) {
      const invoiceNo = event.data.invoice_no;
      if (this.invoiceOrderDetails[invoiceNo]) {
        return;
      }

      this.$set(this.loadingOrderDetail, invoiceNo, true);
      try {
        const response = await lgService.retrievePartOrderStatus(invoiceNo);
        this.$set(this.invoiceOrderDetails, invoiceNo, response);
      } catch (error) {
        const msg = error.response?.data?.message || error.message;
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: msg,
          life: 8000,
        });
      } finally {
        this.$set(this.loadingOrderDetail, invoiceNo, false);
      }
    },
    addPart() {
      this.form.parts.push({ part_no: "", quantity: 1 });
    },
    removePart(index) {
      this.form.parts.splice(index, 1);
    },
    submitComplete() {
      if (!this.form.service_engineer_code) {
        this.$toast.add({
          severity: "warn",
          summary: "Dados em Falta",
          detail: "Código do Técnico é obrigatório.",
          life: 5000,
        });
        return;
      }
      if (!this.form.primary_symptom2_code || !this.form.primary_defect_code || !this.form.primary_repair_code || !this.form.repair_level_code) {
        this.$toast.add({
          severity: "error",
          summary: "Dados Técnicos",
          detail: "Para fechar obra, preencha: Sintoma 2, Defeito, Reparação e Nível de Reparação.",
          life: 5000,
        });
        return;
      }
      if (!this.form.model_code || !this.form.serial_no) {
        this.$toast.add({
          severity: "error",
          summary: "Equipamento",
          detail: "Modelo e Nº Série são obrigatórios para fechar.",
          life: 5000,
        });
        return;
      }

      this.processCompletion();
    },
    processCompletion() {
      this.loading = true;
      const cleanParts = this.form.parts.filter((p) => p.part_no && p.part_no.trim() !== "");

      const payload = {
        pat_id: this.patId,
        rne: this.serviceOrder?.service_receipt_no || this.patInfo?.u_reffabri,
        service_engineer_code: this.form.service_engineer_code,

        start_date: this.formatDate(this.form.start_date),
        completion_time_stamp: this.formatDate(this.form.completion_time_stamp),
        purchase_date: this.formatDate(this.form.purchase_date),
        promise_date: this.formatDate(this.form.promise_date),
        receipt_time_stamp: this.formatDate(this.form.receipt_time_stamp),

        primary_symptom_code: this.form.primary_symptom_code,
        primary_symptom2_code: this.form.primary_symptom2_code,
        primary_defect_code: this.form.primary_defect_code,
        primary_repair_code: this.form.primary_repair_code,
        repair_level_code: this.form.repair_level_code,

        technical_finding_desc: this.form.technical_finding_desc,
        asc_repair_remark_desc: this.form.asc_repair_remark_desc,

        model_code: this.form.model_code?.trim() || "",
        serial_no: this.form.serial_no?.trim() || "",

        req_visit_txn_amount: this.form.req_visit_txn_amount,
        req_labor_cost_txn_amount: this.form.req_labor_cost_txn_amount,

        parts: cleanParts,
      };

      lgService.completeRepair(payload)
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Obra fechada na LG com sucesso.",
            life: 5000,
          });
        })
        .catch((error) => {
          const msg = error.response?.data?.message || error.message;

          this.$toast.add({
            severity: "error",
            summary: "Erro no Fecho",
            detail: msg,
            life: 8000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async submitStatusUpdate() {
      if (!this.statusForm.pending_reason_code) {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "Selecione um estado antes de atualizar.",
          life: 5000,
        });
        return;
      }

      this.loadingStatus = true;
      try {
        const payload = {
          pat_id: this.patId,
          pending_reason_code: this.statusForm.pending_reason_code,
          asc_repair_remark_desc: this.statusForm.asc_repair_remark_desc,
        };

        const response = await lgService.updateStatus(payload);

        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: response.message || "Estado atualizado com sucesso na LG.",
          life: 5000,
        });

        this.statusForm.pending_reason_code = "";
        this.statusForm.asc_repair_remark_desc = "";

        await this.getInfoPat();
      } catch (error) {
        const msg = error.response?.data?.message || error.message;
        this.$toast.add({
          severity: "error",
          summary: "Erro ao Atualizar Estado",
          detail: msg,
          life: 8000,
        });
      } finally {
        this.loadingStatus = false;
      }
    },
    onTabChange(event) {
      if (event.index === 2) {
        this.refreshStatusFromLg();
      }
    },
    async refreshStatusFromLg() {
      if (!this.patId) return;
      this.loadingStatus = true;
      try {
        const response = await lgService.refreshFromLg(this.patId);
        if (response && response.lg_data) {
          this.liveStatus.pending_reason_code = response.lg_data.pending_reason_code || "";
          this.liveStatus.asc_repair_remark_desc = response.lg_data.asc_repair_remark_desc || "";
          this.$toast.add({
            severity: "info",
            summary: "Sincronizado",
            detail: "Estado atual obtido em tempo real da LG.",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Failed to sync live status from LG:", error);
      } finally {
        this.loadingStatus = false;
      }
    },
    getStatusLabel(code) {
      if (!code) return "";
      const match = this.statusOptions.find(opt => opt.value === code);
      return match ? match.label : code;
    },
  },
};
</script>

<style lang="scss" scoped>
.dg-detail {
  &__header {
    margin-bottom: 1rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid var(--surface-border, #dee2e6);

    h3 {
      display: flex;
      align-items: center;
      font-weight: 600;
    }

    small {
      display: block;
      margin-top: 0.25rem;
    }
  }
}
</style>

<style scoped>
.box-upload {
  padding: 1rem;
  border: 1px dashed #ccc;
  border-radius: 4px;
  margin-bottom: 1rem;
}
.box-upload:hover {
  background-color: #f9f9f9;
  border-color: #aaa;
}

.lg-selected-file {
  padding: 0.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
}

.pdf-preview-sm {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  border: 1px dashed #ccc;
  border-radius: 4px;
  background: #fafafa;
}

.required-field {
  color: #e74c3c;
  font-weight: bold;
}
</style>
